import { usePathname, useSearchParams } from 'next/navigation';

const regex = /\/?$/;

/**
 * Gets the full URL (without domain) with support for both pages router and app router, as a companion to `usePathname` and `useSearchParams`.
 *
 * By default returns the URL with no trailing slash, unless `trailingSlash` is set to `true`. Always returns a slash for the root URL, never an empty string, matching default behavior of `location.pathname`.
 *
 * @example
 * useUrl()
 * // no trailing slash, single query param
 * '/foo/bar?a=1'
 * @example
 * useUrl(true)
 * // trailing slash, array query param
 * '/foo/bar/?a=1&b=2&b=3&b=4'
 * @example
 * useUrl()
 * // root, always a non-empty string
 * '/'
 */
export const useUrl = (trailingSlash = false) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isRoot = !pathname || pathname === '/';

  const sanitizedPathname = isRoot ? '/' : pathname.replace(regex, trailingSlash ? '/' : '');
  // NOTE: null check is for pages/app router compat mode, later for pure app router this can never be null
  const serializedParams = searchParams ? searchParams.toString() : '';

  return serializedParams ? `${sanitizedPathname}?${serializedParams}` : sanitizedPathname;
};
